export enum DataType {
    String = 1,
    Integer = 2,
    Float = 3,
    Date = 4,
    Boolean = 5,
    Password = 6,
    Fee = 11,
    ToggleYesNo = 7,
    ToggleYesNoUnknown = 8,
    ToggleYesNoPilot = 9,
    ToggleActiveSuspended = 10,
    ToggleOrganType = 18,
    Select = 12,
    SelectInteger = 14,
    Callout = 13,
    Modal = 15,
    Space = 16,
    Component = 17
};
